
<app-lazy-loading *transloco="let t" [show]="isLoaded">
  <ng-container>
    <section attr.aria-label="{{t('section.online-first.aria-label')}}" *ngIf="articles && articles.length > 0" class="card ap-default-card mb-3">

      <div class="card-header">
        <div class="header-content">{{t('section.online-first.name')}}</div>
      </div>
      <div class="card-body">
        <div *ngFor="let article of articles" class="item clearfix">
          <app-article-short-template [article]="article" [template]="PageType.HOME"></app-article-short-template>
        </div>
      </div>
      <div class="card-footer">
        <div class="float-end clearfix mb-2"><a routerLink="/online-first" title="{{t('alternate.link-articles-online-first')}}"  attr.aria-label="{{t('alternate.link-articles-online-first')}}" >{{ t("btn.all-articles") }} <i class="bi bi-chevron-double-right"></i></a></div>
      </div>
    </section>
  </ng-container>
  <ng-container placeholder>
    <section attr.aria-label="{{t('section.most-read.aria-label')}}"  class="card ap-default-card mb-3">
      <div class="card-header">
        <div class="placeholder w-25">{{t('section.online-first.name')}}</div>
      </div>
      <div class="card-body w-100">
        <div *ngFor="let number of [0,1,2]" class="item item-placeholder w-100 clearfix">
          <span class="title placeholder mt-1 w-25">&nbsp;</span>
          <span class="date placeholder mt-1 w-100">&nbsp;</span>
          <div class="right placeholder mt-1 clearfix w-25" >&nbsp;</div>
          <div class="right placeholder mt-1 clearfix w-25" >&nbsp;</div>
        </div>
      </div>
    </section>
  </ng-container>
</app-lazy-loading>
